import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {defineMessage, FormattedMessage, useIntl} from 'react-intl'
import {
    Box,
    Step,
    StepIndicator,
    StepNumber,
    Stepper,
    StepSeparator,
    StepTitle
} from '@chakra-ui/react'

const STEP_LABELS = {
    PRODUCT_SELECTION: defineMessage({
        id: 'warranty_portal.step.name.product_selection',
        defaultMessage: 'Your product'
    }),
    PRODUCT_DETAILS: defineMessage({
        id: 'warranty_portal.step.name.product_details',
        defaultMessage: 'Product details'
    }),
    POINT_OF_PURCHASE: defineMessage({
        id: 'warranty_portal.step.name.point_of_purchase',
        defaultMessage: 'Point of purchase'
    }),
    CUSTOMER_DATA: defineMessage({
        id: 'warranty_portal.step.name.customer_data',
        defaultMessage: 'Customer data'
    })
}

const WarrantyStepIndicator = ({step, steps}) => {
    const {formatMessage} = useIntl()

    const items = useMemo(
        () =>
            steps.map((id) => ({
                id,
                titleMsg: STEP_LABELS[id]
            })),
        [steps]
    )

    return (
        <Box
            role="group"
            aria-label={formatMessage({
                id: 'warranty_portal.stepper.label',
                defaultMessage: 'Progress'
            })}
        >
            <Stepper
                as="ol"
                index={step}
                // remove the aria label from the list as some SR don't support it and we use the parent group to name it
                aria-label={null}
            >
                {items.map(({id, titleMsg}, index) => (
                    <Step key={id} aria-current={index === step ? true : null} as="li">
                        <StepIndicator>
                            <StepNumber />
                        </StepIndicator>

                        <StepTitle as="p">
                            <FormattedMessage {...titleMsg} />
                        </StepTitle>

                        <StepSeparator />
                    </Step>
                ))}
            </Stepper>
        </Box>
    )
}

WarrantyStepIndicator.propTypes = {
    step: PropTypes.number.isRequired,
    steps: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default WarrantyStepIndicator
